import { MediaQueries, Spacings } from '@ptml/design-system';
import styled, { css } from 'styled-components';

export const MarginWrapper = styled.div<{
    $isActingOnBehalfOf?: boolean;
}>`
    ${({ $isActingOnBehalfOf }) =>
        !$isActingOnBehalfOf &&
        css`
            margin-top: ${Spacings.xxsmall};
        `}

    ${MediaQueries.md} {
        padding-left: 2.25rem;
        padding-right: 2.25rem;
    }
    ${MediaQueries.lg} {
        padding-left: 2.5rem;
        padding-right: 2.5rem;
    }
`;
